import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { StaffTypeData } from 'src/app/models/newModels/StaffTypeData';

@Component({
  selector: 'app-custom-autocomplete',
  templateUrl: './custom-autocomplete.component.html',
  styleUrls: ['./custom-autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: CustomAutocompleteComponent
    }
  ]

})
export class CustomAutocompleteComponent implements OnInit, ControlValueAccessor {
  @Input()
  items: StaffTypeData[] = [];
  @Output()
  valueChange = new EventEmitter<string>();
  itemCtrl: FormControl;
  filteredItems$: Observable<any[]>;
  showAddButton: boolean = false;
  trackByFn = (index: number, item: StaffTypeData) => item.stafftypeid;
  onChange = (item) => { };
  onTouched = () => { };
  touched = false;
  disabled = false;
  id = 0;
  toHighlight: string = ''

  ngOnInit() {
    this.itemCtrl = new FormControl();
    this.filteredItems$ = this.itemCtrl.valueChanges
      .pipe(
        startWith(undefined),
        map(item => this.filterItems(item))
      );
  }

  filterItems(name) {
    if (name !== undefined) {
      this.valueChanged(undefined);
    }
    name = name || ""
    this.toHighlight = name;
    const results = this.items.filter(item => {
      const option = [item.abbreviation, item.stafftypename].join(" ");
      return option.toLocaleLowerCase().includes(name.toLocaleLowerCase());
    });
    this.showAddButton = results.length === 0;
    return results;
  }
  //Method called to add a new staff type in autocomplete options
  addOption() {
    if (this.showAddButton) {
      const abbreviation = this.itemCtrl.value.length <= 4 ? this.itemCtrl.value.toLocaleUpperCase() : this.itemCtrl.value;
      this.items.push({ stafftypeid: --this.id, abbreviation })
      this.sortStaffTypeList()
      this.itemCtrl.setValue(abbreviation)
      this.valueChanged(abbreviation);
      this.showAddButton = false
    }
  }

  sortStaffTypeList() {
    this.items.sort(function (a, b) {
      return a.abbreviation.localeCompare(b.abbreviation);
    });
  }
  //Method called when autocomplete value is changed
  valueChanged(value) {
    const selecteditem = this.items.find(item => item.abbreviation === value)
    this.onChange(selecteditem && selecteditem.stafftypeid);
    this.valueChange.next(value)
  }

  /* Writes a new value to the element.
   * This method is called by the forms API to write to the view when programmatic
   * changes from model to view are requested.
   */
  writeValue(obj: any): void {
    const selecteditem = this.items.find(item => item.stafftypeid === obj)
    this.itemCtrl.setValue(selecteditem && selecteditem.abbreviation, { emitEvent: false })
  }

  //Registers a function called when the control value changes.
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  //Registers a function called when the control is touched
  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }
  //Sets the "disabled" property on the input element.
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  /* Marks the control as `dirty`. A control becomes dirty when
     * the control's value is changed through the UI; compare `markAsTouched`.
  */
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

}
